import { render, staticRenderFns } from "./BitacoraBase.vue?vue&type=template&id=6aff3d7c&"
import script from "./BitacoraBase.vue?vue&type=script&lang=ts&"
export * from "./BitacoraBase.vue?vue&type=script&lang=ts&"
import style0 from "./BitacoraBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6aff3d7c', component.options)
    } else {
      api.reload('6aff3d7c', component.options)
    }
    module.hot.accept("./BitacoraBase.vue?vue&type=template&id=6aff3d7c&", function () {
      api.rerender('6aff3d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Bitacora/BitacoraBase.vue"
export default component.exports